import { render, staticRenderFns } from "./RFQInfo.vue?vue&type=template&id=94c47c2a&scoped=true"
import script from "./RFQInfo.vue?vue&type=script&lang=js"
export * from "./RFQInfo.vue?vue&type=script&lang=js"
import style0 from "./RFQInfo.vue?vue&type=style&index=0&id=94c47c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c47c2a",
  null
  
)

export default component.exports